var chunkMapping = {
	"330": [
		20330
	],
	"1060": [
		11060
	],
	"1538": [
		71538
	],
	"2131": [
		52131
	],
	"3033": [
		53033
	],
	"3270": [
		3270
	],
	"3469": [
		53469
	],
	"4257": [
		64257
	],
	"4656": [
		44656
	],
	"4911": [
		14911
	],
	"5136": [
		25136
	],
	"6276": [
		46276
	],
	"8395": [
		88395
	],
	"9647": [
		42028
	],
	"9650": [
		9650
	]
};
var idToExternalAndNameMapping = {
	"3270": [
		"default",
		"./FederatedReducers",
		79036
	],
	"9650": [
		"default",
		"./BetaProjectReport",
		79036
	],
	"11060": [
		"default",
		"./ActivitiesScreen",
		79036
	],
	"14911": [
		"default",
		"./AutoDialerScreen",
		50373
	],
	"20330": [
		"default",
		"./WhatsappPro",
		79036
	],
	"25136": [
		"default",
		"./BottomNavigation",
		79036
	],
	"42028": [
		"default",
		"./layout-slice",
		79036
	],
	"44656": [
		"default",
		"./WeekView",
		79036
	],
	"46276": [
		"default",
		"./BetaProjectListing",
		79036
	],
	"52131": [
		"default",
		"./BetaReviewReport",
		79036
	],
	"53033": [
		"default",
		"./BetaDigitalReport",
		79036
	],
	"53469": [
		"default",
		"./FollowupForm",
		79036
	],
	"64257": [
		"default",
		"./BetaReviewReportLeadList",
		79036
	],
	"71538": [
		"default",
		"./ProjectReportLeadList",
		79036
	],
	"88395": [
		"default",
		"./FollowUpScreen",
		79036
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}